import { MouseEvent } from 'react';
import { SortOptions } from 'helpers/Links/Links.typed';

export function safeClick(event: MouseEvent) {
  const sure = confirm('Are you sure?');
  if (!sure) {
    event.preventDefault();
  }
}

const generateSimilarCarsLink = (
  make: string,
  model: string,
  year: string,
  sort?: SortOptions,
) => {
  const baseLink = `/cars/${make}/${model}/${year}`;

  if (!sort) {
    return baseLink;
  }

  return `${baseLink}?sort=${sort}`;
};

export { generateSimilarCarsLink };
